<template>
	<v-card
		:elevation="4"
		class="app-dashboard-card-layout h-100"
	>
		<div class="d-flex flex-column h-100 px-4 py-2">
			<div class="dashboard-card-header d-flex pb-2">
				<div class="dashboard-card-title ao-c2-medium text-textSecondary700">
					{{ title }}
				</div>
				<v-spacer/>
				<slot name="header-actions">
					<ao-icon-btn
						v-if="useDetailAction"
						iconName="listView"
						custom="dashboardCardAction"
						class="ms-2"
						@click="$emit('click:detail')"
					/>
				</slot>
			</div>
			<div class="dashboard-card-content flex-grow-1">
				<slot
					name="content"
				/>
			</div>
		</div>
	</v-card>
</template>

<script setup>
defineProps({
	title: {
		type: String,
	},

	useDetailAction: {
		type: Boolean,
		default: false,
	},
})

defineEmits({
	'click:detail': null,
})
</script>
